import { ArticleBatchDto } from '../../../../shared/dto/article-batch.dto';
import { AfterViewInit, Component, ElementRef, EventEmitter, inject, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NzEmptyModule } from 'ng-zorro-antd/empty';
import { NzInputDirective, NzInputGroupComponent, NzInputGroupWhitSuffixOrPrefixDirective } from 'ng-zorro-antd/input';
import { NzMessageModule, NzMessageService } from 'ng-zorro-antd/message';
import { NZ_MODAL_DATA, NzModalFooterDirective, NzModalRef, NzModalTitleDirective } from 'ng-zorro-antd/modal';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzTableCellDirective, NzTableComponent, NzTbodyComponent, NzTheadComponent, NzThMeasureDirective, NzTrDirective } from 'ng-zorro-antd/table';
import { Subject, takeUntil } from 'rxjs';
import { TITLE_TABLE_SIZE } from 'src/app/core/constants/style';
import { ArticleBatchesService } from 'src/app/private/services/article-batches.service';
import { ArticlesService } from 'src/app/private/services/articles.service';
import { ArticleDto } from 'src/app/shared/dto/article.dto';
import { PackagingDto } from '../../../../shared/dto/packaging.dto';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { LoaderComponent } from 'src/app/shared/components/loader/loader.component';
import { PermissionService } from 'src/app/core/services/permission.service';
import { RawMaterialToUseDto } from 'src/app/shared/dto/raw-material-to-use.dto';
import { FinalProductDto } from 'src/app/shared/dto/final-product.dto';
import { UserDto } from 'src/app/shared/dto/user.dto';
import { UserLoggedService } from 'src/app/core/services/userLogged.service';


interface PlainRawMaterial {
    id?: number;
    name: string;
    article?: ArticleDto;
    articleBatch?: ArticleBatchDto;
    packaging?: PackagingDto;
    finalProduct: FinalProductDto;
    measurementUnit?: string;
    quantity: number;
    createdById?: number;
}

@Component({
    selector: 'app-modal-raw-material-to-use',
    templateUrl: './modal-add-raw-materials-to-use.component.html',
    styleUrls: ['./modal-add-raw-materials-to-use.component.scss'],
    standalone: true,
    imports: [
        NzTableComponent,
        NzTheadComponent,
        NzTrDirective,
        NzModalTitleDirective,
        NzTableCellDirective,
        NzThMeasureDirective,
        NzTbodyComponent,
        ReactiveFormsModule,
        FormsModule,
        NzModalFooterDirective,
        NzMessageModule,
        NzSelectModule,
        NzInputDirective,
        NzInputGroupComponent,
        NzIconModule,
        NzToolTipModule,
        NzInputGroupWhitSuffixOrPrefixDirective,
        NzEmptyModule,
        LoaderComponent,
        NzButtonModule
    ],
})
export class ModalAddRawMaterialsToUseComponent implements OnInit, OnDestroy, AfterViewInit {
    @Output() emitService = new EventEmitter();
    @ViewChild('modalContent') private readonly _modalContent!: ElementRef;

    isLoading: boolean = true;
    isSaving: boolean = false;
    rawMaterialsToUse: RawMaterialToUseDto[] = [];
    plainRawMaterials: PlainRawMaterial[] = [];
    finalProducts: FinalProductDto[] = [];
    articles: ArticleDto[] = [];
    articleBatches: ArticleBatchDto[] = [];
    // packagings: PackagingDto[] = [];
    articlesAndBatches: any = [];
    batchesOfArticlesInRawMaterials = new Map<number, ArticleBatchDto[]>();
    // packagingsOfBatchSelected = new Map<number, PackagingDto[]>();
    // packagingsOfArticleSelected = new Map<number, PackagingDto[]>();
    auxModel: number = 0;
    tableHeight!: number;
    canCreate: boolean;
    canEdit: boolean;
    canDelete: boolean;
    isFromOrderProcessDetail:boolean;
    isLocked:boolean = false;
    readonly nzModalData:{nzTitle:string, orderProcessId:number, rawMaterialsToUse: RawMaterialToUseDto[], finalProducts:FinalProductDto[], isFromOrderProcessDetail:boolean, isLocked: boolean} = inject(NZ_MODAL_DATA);

    private articleBatchNumberSearchValue: string = '';
    private loggedUser: UserDto = new UserDto();

    private readonly unsubscribe$ = new Subject();

    private readonly articleService = inject(ArticlesService);
    private readonly articleBatchService = inject(ArticleBatchesService);
    // private readonly packagingsService = inject(PackagingsService);
    private readonly modalRef = inject(NzModalRef);
    private readonly message = inject(NzMessageService);
    private readonly permissionService = inject(PermissionService);
    private readonly userLoggedService = inject(UserLoggedService);

    constructor() {
        const permissionMainKey: string = 'productionOrderProcessDetail';
        const btnName: string = 'btnWatchRawMaterialToUse';

        this.loggedUser = this.userLoggedService.userLogged;
        this.rawMaterialsToUse = this.nzModalData.rawMaterialsToUse ?? [];
        this.finalProducts = this.nzModalData.finalProducts ?? [];
        this.isFromOrderProcessDetail = this.nzModalData.isFromOrderProcessDetail ?? false;
        this.isLocked = this.nzModalData.isLocked ?? false;

        this.canCreate = this.permissionService.canEdit(permissionMainKey, `${btnName}`);
        this.canEdit = this.permissionService.canEdit(permissionMainKey, `${btnName}`);
        this.canDelete = this.permissionService.canDelete(permissionMainKey, `${btnName}`);
    }

    async ngOnInit() {
        if((this.canCreate && this.canEdit && this.isFromOrderProcessDetail) || !this.isFromOrderProcessDetail){
            await this.articleService.setupWebSocket();
            this.articleService.articles$
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe({
                    next: (articles) => {
                        this.articles = articles;
                    },
                    error: () => {
                        this.message.error('No se han podido cargar los artículos.');
                    }
                });

            await this.articleBatchService.setupWebSocket();
            this.articleBatchService.articleBatches$
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe({
                    next: (articleBatches) => {
                        this.articleBatches = articleBatches;
                    },
                    error: () => {
                        this.message.error('No se han podido cargar los lotes de artículos.');
                    }
                });
        }

        this.loadRawMaterialsToUse();
        this.loadBatchesOfArticlesInRawMaterialsToUse();
        this.loadPackagingsOfBatchesAndArticlesSelected();

        this.isLoading = false;
    }

    async ngAfterViewInit(): Promise<void> {
        setTimeout(() => {
            this.tableHeight =
                (this._modalContent.nativeElement as HTMLImageElement)
                    .clientHeight - TITLE_TABLE_SIZE;
        });
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next({});
        this.unsubscribe$.complete();
        if((this.canCreate && this.canEdit && this.isFromOrderProcessDetail) || !this.isFromOrderProcessDetail){
            this.articleService.disconnectWebSocket();
            this.articleBatchService.disconnectWebSocket();
            // this.packagingsService.disconnectWebSocket();
        }
    }

    compareById(o1: any, o2: any): boolean {
        return o1 && o2 ? o1.id === o2.id : o1 === o2;
    }

    compareByObject(o1: any, o2: any): boolean {
        return o1 === o2;
    }

    compareByBatchNumber = (o1: ArticleBatchDto, o2: ArticleBatchDto): boolean => {
        return o1 && o2 ? o1.batchNumber === o2.batchNumber : o1 === o2;
    };

    compareByPackagingElementId = (o1: any, o2: any): boolean => {
        return o1 && o2 ? o1.id === o2.id : o1 === o2;
    };

    async onArticleChanged(articleSelected: ArticleDto, index: number) {
        this.plainRawMaterials[index].articleBatch = undefined;
        this.plainRawMaterials[index].packaging = undefined;
        this.plainRawMaterials[index].quantity = 0;
        this.plainRawMaterials[index].measurementUnit = articleSelected.measurementUnit.abbreviation;

        if (articleSelected.useBatches) {
            const batches = this.articleBatches.filter(batch =>
                batch.articleId === articleSelected.id
            );
            this.batchesOfArticlesInRawMaterials.set(index, batches);
        }

        // if (!articleSelected.useBatches && articleSelected.usePackagings) {
        //     const articlePackagings = await this.packagingsService.getPackagingsByArticleId(articleSelected.id!);
        //     if (articlePackagings && articlePackagings.length > 0) {
        //         this.packagingsOfArticleSelected.set(index, articlePackagings);
        //     } else {
        //         this.packagingsOfArticleSelected.set(index, []);
        //     }
        //     this.plainRawMaterials[index].packaging = new PackagingDto();
        // }
    }

    async onBatchChanged(articleBatch: ArticleBatchDto, index: number) {
        // this.plainRawMaterials[index].packaging = undefined;
        // this.plainRawMaterials[index].quantity = 0;

        // if (articleBatch.article?.usePackagings) {
        //     const batchPackagings = await this.packagingsService.getPackagingsByArticleBatchId(articleBatch.id!);
        //     if (batchPackagings && batchPackagings.length > 0) {
        //         this.packagingsOfBatchSelected.set(index, batchPackagings);
        //         this.plainRawMaterials[index].packaging = new PackagingDto();
        //     } else {
        //         this.packagingsOfBatchSelected.set(index, []);
        //     }
        // }
    }

    onPackagingChanged(packaging: PackagingDto, index: number) {
        this.plainRawMaterials[index].packaging = packaging;
        this.plainRawMaterials[index].measurementUnit = packaging.packagingType!.measurementUnit!.abbreviation;
        this.plainRawMaterials[index].quantity = packaging.packagingType!.quantityPerPackaging;
    }

    filterArticlesSelector(searchValue: string, article: any): boolean {
        if (!searchValue) {
            return true;
        }
        const lowerCaseSearch = searchValue.toLowerCase();
        return (
            article.nzValue.name?.toLowerCase().includes(lowerCaseSearch) ||
            article.nzValue.externalId?.toString().toLowerCase().includes(lowerCaseSearch) ||
            article.nzValue.ean?.toLowerCase().includes(lowerCaseSearch)
        );
    }

    filterArticleBatchesSelector = (searchValue: string, batch: any): boolean => {
        if (!searchValue) {
            return true;
        }
        const lowerCaseSearch = searchValue.toLowerCase();
        return (
            batch.nzValue.batchNumber?.toString().toLowerCase().includes(lowerCaseSearch) ||
            batch.nzValue.externalId?.toString().toLowerCase().includes(lowerCaseSearch)
        );
    };

    filterPackagingOnArticleBatchSelector = (searchValue: string, packaging: any): boolean => {
        if (!searchValue) {
            return true;
        }
        const lowerCaseSearch = searchValue.toLowerCase();
        return (
            packaging.nzValue.packagingBatchExternalId?.toString().toLowerCase().includes(lowerCaseSearch) ||
            packaging.nzValue.externalBatchNumber?.toLowerCase().includes(lowerCaseSearch)
        );
    };

    isArticleDisabled(articleId: number): boolean {
        for (const plainRawMaterial of this.plainRawMaterials) {
            if (plainRawMaterial.article?.id === articleId && (!plainRawMaterial.article.useBatches && !plainRawMaterial.article.usePackagings)) {
                return true;
            }
        }

        return false;
    }

    isArticleBatchDisabled(articleBatchId: number): boolean {
        for (const plainRawMaterial of this.plainRawMaterials) {
            if (plainRawMaterial.articleBatch?.id === articleBatchId && !plainRawMaterial.article?.usePackagings) {
                return true;
            }
        }

        return false;
    }

    isPackagingDisabled(packagingId: number): boolean {
        for (const plainRawMaterial of this.plainRawMaterials) {
            if (plainRawMaterial.packaging?.id === packagingId) {
                return true;
            }
        }

        return false;
    }

    handleSave() {
        this.isSaving = true;

        const rawMaterialsToUpdate: RawMaterialToUseDto[] = [];
        this.plainRawMaterials.forEach(plainRawMaterial => {
            rawMaterialsToUpdate.push({
                id: plainRawMaterial.id ?? undefined,
                article: plainRawMaterial.article ?? undefined,
                estimatedQuantity: plainRawMaterial.quantity,
                finalProduct: plainRawMaterial.finalProduct ?? undefined
            });
        });

        if (!this.validateRawMaterials(rawMaterialsToUpdate)) {
            this.isSaving = false;
            return;
        }

        this.isSaving = false;
        this.emitService.next(rawMaterialsToUpdate);
    }

    deleteRawMaterial(idx: number) {
        this.plainRawMaterials.splice(idx, 1);
        this.plainRawMaterials = [...this.plainRawMaterials];
    }

    handleAddRawMaterial() {
        this.plainRawMaterials = [...this.plainRawMaterials, { finalProduct: this.finalProducts.length === 1 ? this.finalProducts[0] : null ,quantity: 0 } as PlainRawMaterial];
    }

    handleCancel() {
        this.modalRef.close();
    }

    onArticleBatchSearch(value: string, rawMaterialIndex: number): void {
        this.articleBatchNumberSearchValue = value != '' ? value : this.articleBatchNumberSearchValue;

        if (value == '' && this.articleBatchNumberSearchValue !== '') {
            const searchTerm = this.articleBatchNumberSearchValue.trim();

            this.plainRawMaterials[rawMaterialIndex].articleBatch = this.articleBatches.find(batch => batch.batchNumber === searchTerm);

            this.articleBatchNumberSearchValue = '';
        }
    }

    isDisabled(createdById: number | undefined): boolean {
        if (createdById) {
            return createdById != this.loggedUser.id;
        }

        return false;
    }

    private loadRawMaterialsToUse() {
        if (this.rawMaterialsToUse) {
            this.rawMaterialsToUse.forEach((rawMaterialToUse: RawMaterialToUseDto, index) => {
                // const usedPackaging = this.packagings.find(packaging => packaging.id === rawMaterialToUse.packagingToUseId);

                this.plainRawMaterials.push({
                    id: rawMaterialToUse.id ?? undefined,
                    article: rawMaterialToUse.article ?? undefined,
                    name: rawMaterialToUse.article!.name,
                    measurementUnit: rawMaterialToUse.article?.measurementUnit.abbreviation,
                    quantity: rawMaterialToUse.estimatedQuantity,
                    finalProduct: rawMaterialToUse.finalProduct!,
                    createdById: rawMaterialToUse.createdById
                });
            });
        }
    }

    private loadBatchesOfArticlesInRawMaterialsToUse() {
        this.rawMaterialsToUse.forEach((rawMaterialToUse, index) => {
            const batches = this.articleBatches.filter(
                (batch) => batch.articleId === rawMaterialToUse.articleId || batch.articleId === rawMaterialToUse.article!.id
            );

            this.batchesOfArticlesInRawMaterials.set(index, batches);
        });
    }

    private loadPackagingsOfBatchesAndArticlesSelected() {
        // this.rawMaterialsToUse.forEach(async (rawMaterialToUse, index) => {

        //     if (rawMaterialToUse.articleBatch && rawMaterialToUse.articleBatch.article?.usePackagings) {
        //         const batchPackagings = await this.packagingsService.getPackagingsByArticleBatchId(rawMaterialToUse.articleBatch.id!);
        //         this.packagingsOfBatchSelected.set(index, batchPackagings);

        //     } else if (rawMaterialToUse.article && rawMaterialToUse.article.usePackagings) {
        //         const articlePackagings = await this.packagingsService.getPackagingsByArticleId(rawMaterialToUse.article.id!);
        //         this.packagingsOfArticleSelected.set(index, articlePackagings);
        //     }
        // });
    }

    private validateRawMaterials(rawMaterialsToUpdate: RawMaterialToUseDto[]): boolean {

        let isValid: boolean = true;

        rawMaterialsToUpdate.forEach((rawMaterialToUpdate) => {

            if (!rawMaterialToUpdate.article) {
                this.message.error('No hay artículo asignado.');
                isValid = false;
            }

            if (!rawMaterialToUpdate.finalProduct) {
                this.message.error('No hay producto final asignado.');
                isValid = false;
            }
        });

        return isValid;
    }
}
